<template>
  <div v-if="items && items.length" class="mt-1.5">
    <button
      class="text-[10px] text-gray-400 hover:text-gray-600 flex items-center gap-1"
      @click.stop="open = !open"
    >
      <FontAwesomeIcon :icon="['fas', open ? 'chevron-down' : 'chevron-right']" class="text-[8px]" />
      {{ items.length }} evidence {{ items.length === 1 ? 'item' : 'items' }}
    </button>
    <ul v-if="open" class="mt-1 space-y-0.5 border-l-2 border-gray-100 pl-2">
      <li v-for="(e, i) in items" :key="i" class="text-[11px] text-gray-600 leading-snug">
        <span class="text-gray-400">{{ sourceLabel(e.source) }}</span>
        <span v-if="e.date" class="text-gray-400"> · <span class="sensitive" data-spoof-kind="date">{{ e.date }}</span></span>
        <span> · <DemoText :text="e.fact" :record="record" /></span>
      </li>
    </ul>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { EVIDENCE_SOURCE_LABELS } from '@/components/Care_Management/riskTranche';
import DemoText from '@/components/DemoMode/DemoText.vue';

export default {
  name: 'EvidenceList',
  components: { DemoText, FontAwesomeIcon },
  props: {
    items: { type: Array, default: () => [] },
    // Raw patient identifier the evidence belongs to (Demo Mode rewrites).
    record: { type: String, default: null }
  },
  data() {
    return { open: false };
  },
  methods: {
    sourceLabel(key) {
      return EVIDENCE_SOURCE_LABELS[key] || key;
    }
  }
};
</script>
